(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('[data-aplus-section]').forEach(section => {
      if (section.dataset.initialised) return;
      section.dataset.initialised = 'true';
      const track = section.querySelector('[data-aplus-track]');
      const items = section.querySelector('.ta-carousel-items');
      if (track && items) {
        const slides = [...items.children];
        const status = section.querySelector('[data-aplus-status]');
        const previous = section.querySelector('[data-aplus-prev]');
        const next = section.querySelector('[data-aplus-next]');
        const index = () => slides.reduce((best, item, i) => Math.abs(item.offsetLeft - slides[0].offsetLeft - track.scrollLeft) < Math.abs(slides[best].offsetLeft - slides[0].offsetLeft - track.scrollLeft) ? i : best, 0);
        const update = () => {
          const active = index();
          if (status) status.textContent = `${active + 1} / ${slides.length}`;
          if (previous) previous.disabled = active === 0;
          if (next) next.disabled = active === slides.length - 1;
        };
        const move = direction => {
          const target = slides[Math.max(0, Math.min(slides.length - 1, index() + direction))];
          if (target) track.scrollTo({ left: target.offsetLeft - slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous?.addEventListener('click', () => move(-1));
        next?.addEventListener('click', () => move(1));
        track.addEventListener('scroll', update, { passive: true });
        track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
        });
        section.addEventListener('shopify:block:select', event => { const target = event.target.closest('.ta-media-block'); if (target) track.scrollTo({ left: target.offsetLeft - slides[0].offsetLeft, behavior: 'auto' }); });
        update();
      }
      section.querySelectorAll('[data-hotspot-target]').forEach(marker => marker.addEventListener('click', event => {
        const target = document.getElementById(marker.dataset.hotspotTarget);
        if (!target) return;
        event.preventDefault(); target.open = true; target.scrollIntoView({ block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        const summary = target.querySelector('summary'); if (summary) summary.focus({ preventScroll: true });
      }));
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
